{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCCustomList;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCCustomScrollControl,
  WEBLib.Controls
  {$IFNDEF LCLWEBLIB}
  ,UITypes, Generics.Collections, Types
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  //version history
  //v1.0.0.0: First Release

type
  TTMSFNCCustomList = class;

  TTMSFNCCustomListItemState = (isNormal, isHover, isDown, isSelected, isDisabled);
  TTMSFNCCustomListItemType = (lbtDefault, lbtDropDown);

  TTMSFNCCustomListItem = class(TCollectionItem)
  private
    FRowSpan: Integer;
    FColumnSpan: Integer;
    FVisible: Boolean;
    FText: string;
    FEnabled: Boolean;
    FMargins: TTMSFNCMargins;
    FCanDeselect: Boolean;
    FCanSelect: Boolean;
    FVerticalTextAlign: TTMSFNCGraphicsTextAlign;
    FHorizontalTextAlign: TTMSFNCGraphicsTextAlign;
    FHint: string;
    FDataBoolean: Boolean;
    FDataString: string;
    FDataObject: TObject;
    FDataInteger: NativeInt;
    FEmpty: Boolean;
    FSelected: Boolean;
    procedure SetColumnSpan(const Value: Integer);
    procedure SetRowSpan(const Value: Integer);
    procedure SetVisible(const Value: Boolean);
    procedure SetText(const Value: string);
    procedure SetEnabled(const Value: Boolean);
    procedure SetMargins(const Value: TTMSFNCMargins);
    procedure SetCanDeselect(const Value: Boolean);
    procedure SetCanSelect(const Value: Boolean);
    procedure SetHorizontalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetVerticalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetEmpty(const Value: Boolean);
    procedure SetSelected(const Value: Boolean);
  protected
    FOwner: TTMSFNCCustomList;
    procedure InvalidateItems;
    procedure MarginsChanged(Sender: TObject);
    property Text: string read FText write SetText;
    property HorizontalTextAlign: TTMSFNCGraphicsTextAlign read FHorizontalTextAlign write SetHorizontalTextAlign default gtaCenter;
    property VerticalTextAlign: TTMSFNCGraphicsTextAlign read FVerticalTextAlign write SetVerticalTextAlign default gtaCenter;
    property Empty: Boolean read FEmpty write SetEmpty default False;
    property CanSelect: Boolean read FCanSelect write SetCanSelect default True;
    property CanDeselect: Boolean read FCanDeselect write SetCanDeselect default True;
  public
    constructor Create(ACollection: TCollection); override;
    procedure Assign(Source: TPersistent); override;
    function State: TTMSFNCCustomListItemState;
    destructor Destroy; override;
    property DataBoolean: Boolean read FDataBoolean write FDataBoolean;
    property DataObject: TObject read FDataObject write FDataObject;
    property DataString: string read FDataString write FDataString;
    property DataInteger: NativeInt read FDataInteger write FDataInteger;
    property Selected: Boolean read FSelected write SetSelected;
  published
    property ColumnSpan: Integer read FColumnSpan write SetColumnSpan default 1;
    property RowSpan: Integer read FRowSpan write SetRowSpan default 1;
    property Visible: Boolean read FVisible write SetVisible default True;
    property Enabled: Boolean read FEnabled write SetEnabled default True;
    property Margins: TTMSFNCMargins read FMargins write SetMargins;
    property Hint: string read FHint write FHint;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCCustomListItems = class(TTMSFNCOwnedCollection)
  {$ELSE}
  TTMSFNCCustomListItems = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSFNCOwnedCollection<TTMSFNCCustomListItem>)
  {$ENDIF}
  private
    FOwner: TTMSFNCCustomList;
    function GetItem(Index: Integer): TTMSFNCCustomListItem;
    procedure SetItem(Index: Integer; const Value: TTMSFNCCustomListItem);
  protected
    function CreateItemClass: TCollectionItemClass; virtual;
    function GetOwner: TPersistent; override;
  public
    constructor Create(AOwner: TTMSFNCCustomList); virtual;
    property Items[Index: Integer]: TTMSFNCCustomListItem read GetItem write SetItem; default;
    function Add: TTMSFNCCustomListItem;
    function Insert(Index: Integer): TTMSFNCCustomListItem;
  end;

  TTMSFNCCustomListAppearance = class(TPersistent)
  private
    FOwner: TTMSFNCCustomList;
    FStrokeHover: TTMSFNCGraphicsStroke;
    FFillDown: TTMSFNCGraphicsFill;
    FVerticalSpacing: Single;
    FStrokeDown: TTMSFNCGraphicsStroke;
    FFillSelected: TTMSFNCGraphicsFill;
    FHorizontalSpacing: Single;
    FStrokeSelected: TTMSFNCGraphicsStroke;
    FFill: TTMSFNCGraphicsFill;
    FFillHover: TTMSFNCGraphicsFill;
    FStroke: TTMSFNCGraphicsStroke;
    FFillDisabled: TTMSFNCGraphicsFill;
    FStrokeDisabled: TTMSFNCGraphicsStroke;
    FFont: TTMSFNCGraphicsFont;
    FItemHeight: Single;
    FItemWidth: Single;
    FTextFormat: string;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetFillDown(const Value: TTMSFNCGraphicsFill);
    procedure SetFillHover(const Value: TTMSFNCGraphicsFill);
    procedure SetFillSelected(const Value: TTMSFNCGraphicsFill);
    procedure SetHorizontalSpacing(const Value: Single);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetStrokeDown(const Value: TTMSFNCGraphicsStroke);
    procedure SetStrokeHover(const Value: TTMSFNCGraphicsStroke);
    procedure SetStrokeSelected(const Value: TTMSFNCGraphicsStroke);
    procedure SetVerticalSpacing(const Value: Single);
    procedure SetFillDisabled(const Value: TTMSFNCGraphicsFill);
    procedure SetStrokeDisabled(const Value: TTMSFNCGraphicsStroke);
    procedure SetFont(const Value: TTMSFNCGraphicsFont);
    function IsHorizontalSpacingStored: Boolean;
    function IsVerticalSpacingStored: Boolean;
    function IsItemHeightStored: Boolean;
    function IsItemWidthStored: Boolean;
    procedure SetItemHeight(const Value: Single);
    procedure SetItemWidth(const Value: Single);
    procedure SetTextFormat(const Value: string);
    function IsTextFormatStored: Boolean;
  protected
    procedure Changed;
    procedure FontChanged(Sender: TObject);
    procedure FillChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
  public
    constructor Create(AOwner: TTMSFNCCustomList);
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property ItemWidth: Single read FItemWidth write SetItemWidth stored IsItemWidthStored nodefault;
    property ItemHeight: Single read FItemHeight write SetItemHeight stored IsItemHeightStored nodefault;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property StrokeHover: TTMSFNCGraphicsStroke read FStrokeHover write SetStrokeHover;
    property FillHover: TTMSFNCGraphicsFill read FFillHover write SetFillHover;
    property StrokeDown: TTMSFNCGraphicsStroke read FStrokeDown write SetStrokeDown;
    property FillDown: TTMSFNCGraphicsFill read FFillDown write SetFillDown;
    property StrokeSelected: TTMSFNCGraphicsStroke read FStrokeSelected write SetStrokeSelected;
    property FillSelected: TTMSFNCGraphicsFill read FFillSelected write SetFillSelected;
    property StrokeDisabled: TTMSFNCGraphicsStroke read FStrokeDisabled write SetStrokeDisabled;
    property FillDisabled: TTMSFNCGraphicsFill read FFillDisabled write SetFillDisabled;
    property VerticalSpacing: Single read FVerticalSpacing write SetVerticalSpacing stored IsVerticalSpacingStored nodefault;
    property HorizontalSpacing: Single read FHorizontalSpacing write SetHorizontalSpacing stored IsHorizontalSpacingStored nodefault;
    property Font: TTMSFNCGraphicsFont read FFont write SetFont;
    property TextFormat: string read FTextFormat write SetTextFormat stored IsTextFormatStored nodefault;
  end;

  TTMSFNCCustomListDisplayItem = record
    Rect: TRectF;
    AbsRect: TRectF;
    Item: TTMSFNCCustomListItem;
    PageIndex: Integer;
    Column, Row, ColumnSpan, RowSpan: Integer;
    {$IFDEF LCLLIB}
    class operator = (z1, z2 : TTMSFNCCustomListDisplayItem) b : Boolean;
    {$ENDIF}
  end;

  TTMSFNCCustomListItemPosArray = array of array of Boolean;

  TTMSFNCCustomListItemSelected = procedure(Sender: TObject; AItemIndex: Integer) of object;
  TTMSFNCCustomListItemDeselected = procedure(Sender: TObject; AItemIndex: Integer) of object;
  TTMSFNCCustomListItemClick = procedure(Sender: TObject; AItemIndex: Integer) of object;
  TTMSFNCCustomListItemBeforeDrawBackground = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean) of object;
  TTMSFNCCustomListItemAfterDrawBackground = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer) of object;
  TTMSFNCCustomListItemBeforeDrawContent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean) of object;
  TTMSFNCCustomListItemAfterDrawContent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer) of object;
  TTMSFNCCustomListItemBeforeDrawText = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var AText: String; var ADefaultDraw: Boolean) of object;
  TTMSFNCCustomListItemAfterDrawText = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; AText: String) of object;
  TTMSFNCCustomListBeforeDraw = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; var ADefaultDraw: Boolean) of object;
  TTMSFNCCustomListAfterDraw = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF) of object;

  {$IFDEF WEBLIB}
  TTMSFNCCustomListDisplayList = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCCustomListDisplayItem;
    procedure SetItem(Index: Integer; const Value: TTMSFNCCustomListDisplayItem);
  public
    property Items[Index: Integer]: TTMSFNCCustomListDisplayItem read GetItem write SetItem; default;
  end;
  {$ELSE}
  TTMSFNCCustomListDisplayList = TList<TTMSFNCCustomListDisplayItem>;
  {$ENDIF}

  TTMSFNCCustomListMode = (bsmBlocks, bsmLines);
  TTMSFNCCustomListOrientation = (toVertical, toHorizontal);

  TTMSFNCCustomList = class(TTMSFNCCustomScrollControl)
  private
    FDownX, FDownY: Single;
    FDisplayList: TTMSFNCCustomListDisplayList;
    FUpdateCount: Integer;
    FRows: Integer;
    FColumns: Integer;
    FPageCount: Integer;
    FItems: TTMSFNCCustomListItems;
    FAppearance: TTMSFNCCustomListAppearance;
    FSelectedItemIndex, FFocusedItemIndex, FHoveredItemIndex, FDownItemIndex, FDragItemIndex: Integer;
    FOnItemBeforeDrawText: TTMSFNCCustomListItemBeforeDrawText;
    FOnAfterDraw: TTMSFNCCustomListAfterDraw;
    FOnItemAfterDrawBackground: TTMSFNCCustomListItemAfterDrawBackground;
    FOnItemSelected: TTMSFNCCustomListItemSelected;
    FOnItemAfterDrawText: TTMSFNCCustomListItemAfterDrawText;
    FOnBeforeDraw: TTMSFNCCustomListBeforeDraw;
    FOnItemBeforeDrawBackground: TTMSFNCCustomListItemBeforeDrawBackground;
    FOnItemDeselected: TTMSFNCCustomListItemDeselected;
    FOnItemClick: TTMSFNCCustomListItemClick;
    FOnItemBeforeDrawContent: TTMSFNCCustomListItemBeforeDrawContent;
    FOnItemAfterDrawContent: TTMSFNCCustomListItemAfterDrawContent;
    FOnInternalItemInserting: TNotifyEvent;
    FOrientation: TTMSFNCCustomListOrientation;
    FAllowMultiSelect: Boolean;
    procedure SetColumns(const Value: Integer);
    procedure SetRows(const Value: Integer);
    procedure SetAppearance(const Value: TTMSFNCCustomListAppearance);
    procedure SetSelectedItemIndex(const Value: Integer);
    //procedure RegisterRuntimeClasses;
    procedure SetAllowMultiSelect(const Value: Boolean);
    procedure SetItems(const Value: TTMSFNCCustomListItems);
  protected
    procedure SetOrientation(const Value: TTMSFNCCustomListOrientation); virtual;
    function GetHintString: string; override;
    function HasHint: Boolean; override;
    function GetVersion: String; override;
    function GetDisplayItem(AItemIndex: Integer): TTMSFNCCustomListDisplayItem;
    function GetNextSelectableItem: Integer;
    function GetPreviousSelectableItem: Integer;
    function GetNextSelectableRowItem: Integer;
    function GetPreviousSelectableRowItem: Integer;
    function GetFirstSelectableItem: Integer;
    function GetLastSelectableItem: Integer;
    function CreateItemsCollection: TTMSFNCCustomListItems; virtual;
    function ColumnStretchingActive: Boolean; override;
    procedure ChangeDPIScale({%H-}M, {%H-}D: Integer); override;
    procedure VerticalScrollPositionChanged; override;
    procedure HorizontalScrollPositionChanged; override;
    procedure CalculateItems(ARealign: Boolean = True);
    procedure UpdateControlScroll({%H-}AHorizontalPos, {%H-}AVerticalPos, {%H-}ANewHorizontalPos, {%H-}ANewVerticalPos: Double); override;
    procedure ApplyStyle; override;
    procedure ResetToDefaultStyle; override;
    procedure InvalidateItems;
    procedure DoItemSelected(AItemIndex: Integer); virtual;
    procedure DoItemClick(AItemIndex: Integer); virtual;
    procedure DoItemDeselected(AItemIndex: Integer); virtual;
    procedure DoItemBeforeDrawBackground(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean); virtual;
    procedure DoItemAfterDrawBackground(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer); virtual;
    procedure DoItemBeforeDrawContent(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean); virtual;
    procedure DoItemAfterDrawContent(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer); virtual;
    procedure DoItemBeforeDrawText(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; var AText: String; var ADefaultDraw: Boolean); virtual;
    procedure DoItemAfterDrawText(AGraphics: TTMSFNCGraphics; ARect: TRectF; AItemIndex: Integer; AText: String); virtual;
    procedure DoItemDrawContent(AGraphics: TTMSFNCGraphics; ARecT: TRectF; AItem: TTMSFNCCustomListItem); virtual;
    procedure DoBeforeDraw(AGraphics: TTMSFNCGraphics; ARect: TRectF; var ADefaultDraw: Boolean); reintroduce; virtual;
    procedure DoAfterDraw(AGraphics: TTMSFNCGraphics; ARect: TRectF); reintroduce; virtual;
    procedure DrawItems(AGraphics: TTMSFNCGraphics); virtual;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    procedure DrawItem(AGraphics: TTMSFNCGraphics; ADisplayItem: TTMSFNCCustomListDisplayItem); virtual;
    procedure DrawItemBackGround(AGraphics: TTMSFNCGraphics; ADisplayItem: TTMSFNCCustomListDisplayItem); virtual;
    procedure DrawItemContent(AGraphics: TTMSFNCGraphics; ADisplayItem: TTMSFNCCustomListDisplayItem); virtual;
    procedure DrawItemText(AGraphics: TTMSFNCGraphics; ADisplayItem: TTMSFNCCustomListDisplayItem); virtual;
    procedure HandleMouseWheel(Shift: TShiftState; WheelDelta: Integer; var Handled: Boolean); override;
    procedure HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X: Single; Y: Single); override;
    procedure HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState; X: Single; Y: Single); override;
    procedure HandleMouseMove(Shift: TShiftState; X: Single; Y: Single); override;
    procedure HandleKeyDown(var Key: Word; Shift: TShiftState); override;
    procedure HandleKeyUp(var Key: Word; Shift: TShiftState); override;
    procedure HandleMouseLeave; override;
    procedure ProcessSelection(AItemIndex: Integer);
    property DisplayList: TTMSFNCCustomListDisplayList read FDisplayList write FDisplayList;
    property AllowMultiSelect: Boolean read FAllowMultiSelect write SetAllowMultiSelect default False;
    property Orientation: TTMSFNCCustomListOrientation read FOrientation write SetOrientation default toHorizontal;
    property SelectedItemIndex: Integer read FSelectedItemIndex write SetSelectedItemIndex default -1;
    property DragItemIndex: Integer read FDragItemIndex default -1;
    property Rows: Integer read FRows write SetRows;
    property Columns: Integer read FColumns write SetColumns;
    property Items: TTMSFNCCustomListItems read FItems write SetItems;
    property Appearance: TTMSFNCCustomListAppearance read FAppearance write SetAppearance;
    property OnItemSelected: TTMSFNCCustomListItemSelected read FOnItemSelected write FOnItemSelected;
    property OnItemDeselected: TTMSFNCCustomListItemDeselected read FOnItemDeselected write FOnItemDeselected;
    property OnItemClick: TTMSFNCCustomListItemClick read FOnItemClick write FOnItemClick;
    property OnItemBeforeDrawBackground: TTMSFNCCustomListItemBeforeDrawBackground read FOnItemBeforeDrawBackground write FOnItemBeforeDrawBackground;
    property OnItemAfterDrawBackground: TTMSFNCCustomListItemAfterDrawBackground read FOnItemAfterDrawBackground write FOnItemAfterDrawBackground;
    property OnItemBeforeDrawContent: TTMSFNCCustomListItemBeforeDrawContent read FOnItemBeforeDrawContent write FOnItemBeforeDrawContent;
    property OnItemAfterDrawContent: TTMSFNCCustomListItemAfterDrawContent read FOnItemAfterDrawContent write FOnItemAfterDrawContent;
    property OnBeforeDraw: TTMSFNCCustomListBeforeDraw read FOnBeforeDraw write FOnBeforeDraw;
    property OnAfterDraw: TTMSFNCCustomListAfterDraw read FOnAfterDraw write FOnAfterDraw;
    property OnItemBeforeDrawText: TTMSFNCCustomListItemBeforeDrawText read FOnItemBeforeDrawText write FOnItemBeforeDrawText;
    property OnItemAfterDrawText: TTMSFNCCustomListItemAfterDrawText read FOnItemAfterDrawText write FOnItemAfterDrawText;
    property OnInternalItemInserting: TNotifyEvent read FOnInternalItemInserting write FOnInternalItemInserting;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    procedure BeginUpdate; override;
    procedure EndUpdate; override;
    procedure Rebuild; virtual;
    procedure UpdateControlAfterResize; override;
    procedure InitializeDefault; virtual;
    function XYToItem(X, Y: Single): Integer;
  end;

implementation

uses
  SysUtils, WEBLib.Graphics, Math, WEBLib.Forms, WEBLib.TMSFNCUtils, WEBLib.TMSFNCStyles;

{ TTMSFNCCustomList }

procedure TTMSFNCCustomList.ApplyStyle;
var
  c: TTMSFNCGraphicsColor;
begin
  inherited;

  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundFillColor(c) then
    Fill.Color := c;

  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundStrokeColor(c) then
    Stroke.Color := c;

  c := gcNull;
  if TTMSFNCStyles.GetStyleDefaultButtonFillColor(c) then
    Appearance.Fill.Color := c;

  c := gcNull;
  if TTMSFNCStyles.GetStyleSelectionFillColor(c) then
  begin
    Appearance.FillSelected.Color := c;
    Appearance.FillDown.Color := c;
    Appearance.FillHover.Color := Blend(c, Appearance.Fill.Color, 25);
  end;

  c := gcNull;
  if TTMSFNCStyles.GetStyleDefaultButtonStrokeColor(c) then
  begin
    Appearance.Stroke.Color := c;
    Appearance.StrokeSelected.Color := c;
    Appearance.StrokeDown.Color := c;
    Appearance.StrokeHover.Color := c;
  end;

  c := gcNull;
  if TTMSFNCStyles.GetStyleTextFontColor(c) then
    Appearance.Font.Color := c;
end;

procedure TTMSFNCCustomList.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomList then
  begin
    FItems.Assign((Source as TTMSFNCCustomList).Items);
    FAppearance.Assign((Source as TTMSFNCCustomList).Appearance);
    FRows := (Source as TTMSFNCCustomList).Rows;
    FColumns := (Source as TTMSFNCCustomList).Columns;
  end;
end;

procedure TTMSFNCCustomList.BeginUpdate;
begin
  inherited;
  Inc(FUpdateCount);
end;

procedure TTMSFNCCustomList.CalculateItems(ARealign: Boolean = True);
var
  itposarr: TTMSFNCCustomListItemPosArray;
  r, newr, c, newc: Integer;
  AItemIndex: Integer;
  AItem: TTMSFNCCustomListItem;
  cspan, rspan, newcspan, newrspan: Integer;
  I: Integer;
  K: Integer;
  sepc: Integer;
  f: Boolean;
  APageIndex: Integer;
  hs, vs: Single;
  iw, ih: Single;
  w, h: Single;
  exw, exh: Single;
  tx, ty, txx, tyy: Single;
  pw, ph: Single;
  sch, scv: Single;
  offs: Single;
  itd: TTMSFNCCustomListDisplayItem;
  rc: TRectF;

  procedure FindNewPos(AItem: TTMSFNCCustomListItem; var ANewR: Integer; var ANewC: Integer; var AFound: Boolean; ARows , {%H-}ACurRow, AColumns, {%H-}ACurCol: Integer; PosArr: TTMSFNCCustomListItemPosArray);
  var
    i, k: integer;
    cspan, rspan: Integer;
    J, L: Integer;
  begin
    AFound := False;
    for I := ANewr to ARows - 1 do
    begin
      for K := ANewC to AColumns - 1 do
      begin
        cspan := AItem.ColumnSpan;
        cspan := Min(cspan, Columns - ANewC);
        rspan := AItem.RowSpan;
        rspan := Min(rspan, Rows - ANewR);

        AFound := true;
        for J := 0 to rspan - 1 do
        begin
          for L := 0 to cspan - 1 do
          begin
            if PosArr[I + J, K + L] then
              AFound := False;
          end;
        end;

        if AFound then
          Break;
        Inc(ANewC);
      end;
      if AFound then
        Break;

      ANewC := 0;
      Inc(ANewr);
    end;
  end;
begin
  if (csDestroying in ComponentState) or (FUpdateCount > 0) then
    Exit;

  FDisplayList.Clear;

  if Items.Count = 0 then
    Exit;

  rc := GetContentRect;
  pw := rc.Right - rc.Left;
  ph := rc.Bottom - rc.Top;
  sch := -GetHorizontalScrollPosition;
  scv := -GetVerticalScrollPosition;
  hs := Appearance.HorizontalSpacing;
  vs := Appearance.VerticalSpacing;
  w := pw - vs;
  iw := w;
  if Appearance.ItemWidth > -1 then
    iw := ScalePaintValue(Appearance.ItemWidth)
  else if Columns > 0 then
    iw := (w - (Columns * hs)) / Columns;

  h := ph - vs;
  sepc := 0;
  ih := h;
  if Appearance.ItemHeight > -1 then
    ih := ScalePaintValue(Appearance.ItemHeight)
  else if (Rows - sepc) > 0 then
    ih := (h - (Rows * vs)) / Rows;

  AItemIndex := 0;
  APageIndex := 0;
  offs := 0;
  while AItemIndex <= Items.Count - 1 do
  begin
    c := 0;
    r := 0;
    SetLength(itposarr, 0, 0);
    SetLength(itposarr, Rows, Columns);

    while r < Rows do
    begin
      while (c < Columns) do
      begin
        if (AItemIndex >= 0) and (AItemIndex <= Items.Count - 1) and (APageIndex = 0) then
        begin
          AItem := Items[AItemIndex];
          if not AItem.Visible then
          begin
            Inc(AItemIndex);
            Continue;
          end;

          cspan := AItem.ColumnSpan;
          rspan := AItem.RowSpan;

          cspan := Min(cspan, Columns - c);
          rspan := Min(rspan, Rows - r);

          exw := iw * cspan + (hs * (cspan - 1));
          exh := ih * rspan + (vs * (rspan - 1));

          txx := (pw * APageIndex) + hs + iw * c + (hs * c);
          tyy := offs + vs + ih * r + (vs * r);

          tx := txx + sch;
          ty := tyy + scv;

          itd.Rect := RectF(tx + AItem.Margins.Left, ty + AItem.Margins.Top,
            tx + exw - AItem.Margins.Right, ty + exh - AItem.Margins.Bottom);
          itd.AbsRect := RectF(txx + AItem.Margins.Left, tyy + AItem.Margins.Top,
            txx + exw - AItem.Margins.Right, tyy + exh - AItem.Margins.Bottom);
          itd.Item := AItem;
          itd.PageIndex := APageIndex;
          itd.Column := c;
          itd.Row := r;
          itd.ColumnSpan := cspan;
          itd.RowSpan := rspan;
          FDisplayList.Add(itd);

          newcspan := c;
          newrspan := r;
          newcspan := newcspan + cspan - 1;
          newrspan := newrspan + rspan - 1;

          for I := r to newrspan do
            for K := c to newcspan do
              itposarr[I, K] := True;
        end;
        Inc(AItemIndex);
        Inc(c);
        newc := c;
        newr := r;
        f := False;
        if (AItemIndex >= 0) and (AItemIndex <= Items.Count - 1) then
          FindNewPos(Items[AItemIndex], newr, newc, f, Rows, newr, Columns, newc, itposarr);
        c := newc;
        r := newr;

        if (c >= Columns) or (r >= Rows) then
          Break;
      end;
      c := 0;
      Inc(r);
      newc := c;
      newr := r;
      f := False;
      if (AItemIndex >= 0) and (AItemIndex <= Items.Count - 1) then
        FindNewPos(Items[AItemIndex], newr, newc, f, Rows, newr, Columns, newc, itposarr);
      c := newc;
      r := newr;
      if r >= Rows then
        Break;
    end;
    Inc(APageIndex);
  end;

  FPageCount := APageIndex;

  if ARealign then
  begin
    UpdateControlScrollBars;
    CalculateItems(False)
  end
  else
    InvalidateItems;
end;

procedure TTMSFNCCustomList.ChangeDPIScale(M, D: Integer);
begin
  inherited;
  Appearance.Font.Height := TTMSFNCUtils.MulDivInt(Appearance.Font.Height, M, D);
end;

function TTMSFNCCustomList.ColumnStretchingActive: Boolean;
begin
  Result := False;
end;

constructor TTMSFNCCustomList.Create(AOwner: TComponent);
begin
  inherited;
  {$IFNDEF WEBLIB}
  NativeCanvas := True;
  AntiAliasing := True;
  {$ENDIF}
  TouchScrolling := True;
  FColumns := 1;
  FRows := 1;
  FItems := CreateItemsCollection;
  FDisplayList := TTMSFNCCustomListDisplayList.Create;
  FAppearance := TTMSFNCCustomListAppearance.Create(Self);
  FDragItemIndex := -1;
  FSelectedItemIndex := -1;
  FFocusedItemIndex := -1;
  FHoveredItemIndex := -1;
  FDownItemIndex := -1;
  FOrientation := toHorizontal;
  FAllowMultiSelect := False;

  Width := 300;
  Height := 50;
end;

procedure TTMSFNCCustomList.InitializeDefault;
begin
  Rebuild;
end;

function TTMSFNCCustomList.CreateItemsCollection: TTMSFNCCustomListItems;
begin
  Result := TTMSFNCCustomListItems.Create(Self);
end;

destructor TTMSFNCCustomList.Destroy;
begin
  FAppearance.Free;
  FDisplayList.Free;
  FItems.Free;
  inherited;
end;

procedure TTMSFNCCustomList.DoAfterDraw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
begin
  if Assigned(OnAfterDraw) then
    OnAfterDraw(Self, AGraphics, ARect);
end;

procedure TTMSFNCCustomList.DoBeforeDraw(AGraphics: TTMSFNCGraphics; ARect: TRectF;
  var ADefaultDraw: Boolean);
begin
  if Assigned(OnBeforeDraw) then
    OnBeforeDraw(Self, AGraphics, ARect, ADefaultDraw);
end;

procedure TTMSFNCCustomList.DoItemAfterDrawBackground(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer);
begin
  if Assigned(OnItemAfterDrawBackground) then
    OnItemAfterDrawBackground(Self, AGraphics, ARect, AItemIndex);
end;

procedure TTMSFNCCustomList.DoItemAfterDrawContent(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer);
begin
  if Assigned(OnItemAfterDrawContent) then
    OnItemAfterDrawContent(Self, AGraphics, ARect, AItemIndex);
end;

procedure TTMSFNCCustomList.DoItemAfterDrawText(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer; AText: String);
begin
  if Assigned(OnItemAfterDrawText) then
    OnItemAfterDrawText(Self, AGraphics, ARect, AItemIndex, AText);
end;

procedure TTMSFNCCustomList.DoItemBeforeDrawBackground(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean);
begin
  if Assigned(OnItemBeforeDrawBackground) then
    OnItemBeforeDrawBackground(Self, AGraphics, ARect, AItemIndex, ADefaultDraw);
end;

procedure TTMSFNCCustomList.DoItemBeforeDrawContent(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer; var ADefaultDraw: Boolean);
begin
  if Assigned(OnItemBeforeDrawContent) then
    OnItemBeforeDrawContent(Self, AGraphics, ARect, AItemIndex, ADefaultDraw);
end;

procedure TTMSFNCCustomList.DoItemBeforeDrawText(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AItemIndex: Integer; var AText: String;
  var ADefaultDraw: Boolean);
begin
  if Assigned(OnItemBeforeDrawText) then
    OnItemBeforeDrawText(Self, AGraphics, ARect, AItemIndex, AText, ADefaultDraw);
end;

procedure TTMSFNCCustomList.DoItemSelected(AItemIndex: Integer);
begin
  if Assigned(OnItemSelected) then
    OnItemSelected(Self, AItemIndex);
end;

procedure TTMSFNCCustomList.DoItemClick(AItemIndex: Integer);
begin
  if Assigned(OnItemClick) then
    OnItemClick(Self, AItemIndex);
end;

procedure TTMSFNCCustomList.DoItemDeselected(AItemIndex: Integer);
begin
  if Assigned(OnItemDeselected) then
    OnItemDeselected(Self, AItemIndex);
end;

procedure TTMSFNCCustomList.DoItemDrawContent(AGraphics: TTMSFNCGraphics;
  ARecT: TRectF; AItem: TTMSFNCCustomListItem);
begin

end;

procedure TTMSFNCCustomList.HandleMouseLeave;
begin
  inherited;
  FHoveredItemIndex := -1;
  InvalidateItems;
end;

procedure TTMSFNCCustomList.DrawItem(AGraphics: TTMSFNCGraphics;
  ADisplayItem: TTMSFNCCustomListDisplayItem);
begin
  if Assigned(ADisplayItem.Item) and ADisplayItem.Item.Empty then
    Exit;

  DrawItemBackGround(AGraphics, ADisplayItem);
  DrawItemContent(AGraphics, ADisplayItem);
  DrawItemText(AGraphics, ADisplayItem);
end;

procedure TTMSFNCCustomList.DrawItemBackGround(AGraphics: TTMSFNCGraphics; ADisplayItem: TTMSFNCCustomListDisplayItem);
var
  r: TRectF;
  it: TTMSFNCCustomListItem;
  a: Boolean;
  fr: TRectF;
begin
  it := ADisplayItem.Item;
  if Assigned(it) then
  begin
    AGraphics.Fill.Assign(Appearance.Fill);
    AGraphics.Stroke.Assign(Appearance.Stroke);
    if it.Enabled then
    begin
      if it.Index = FDownItemIndex then
      begin
        AGraphics.Fill.Assign(Appearance.FillDown);
        AGraphics.Stroke.Assign(Appearance.StrokeDown);
      end
      else if it.Index = FHoveredItemIndex then
      begin
        AGraphics.Fill.Assign(Appearance.FillHover);
        AGraphics.Stroke.Assign(Appearance.StrokeHover);
      end
      else if it.Selected then
      begin
        AGraphics.Fill.Assign(Appearance.FillSelected);
        AGraphics.Stroke.Assign(Appearance.StrokeSelected);
      end;
    end
    else
    begin
      AGraphics.Fill.Assign(Appearance.FillDisabled);
      AGraphics.Stroke.Assign(Appearance.StrokeDisabled);
    end;

    r := ADisplayItem.Rect;
    a := True;
    DoItemBeforeDrawBackground(AGraphics, ADisplayItem.Rect, it.Index, a);
    if a then
    begin
      AGraphics.DrawRectangle(r);
      if IsFocused and (FFocusedItemIndex = it.Index) then
      begin
        fr := r;
        InflateRectEx(fr, ScalePaintValue(-2), ScalePaintValue(-2));
        AGraphics.DrawFocusRectangle(fr);
      end;

      DoItemAfterDrawBackground(AGraphics, ADisplayItem.Rect, it.Index);
    end;
  end;
end;

procedure TTMSFNCCustomList.DrawItemContent(AGraphics: TTMSFNCGraphics;
  ADisplayItem: TTMSFNCCustomListDisplayItem);
var
  it: TTMSFNCCustomListItem;
  a: Boolean;
  r: TRectF;
  fh: Single;
begin
  it := ADisplayItem.Item;
  if Assigned(it) then
  begin
    r := ADisplayItem.Rect;

    AGraphics.Font.Assign(Appearance.Font);
    if it.Text <> '' then
      fh := AGraphics.CalculateTextHeight(it.Text)
    else
      fh := 0;

    if it.VerticalTextAlign = gtaTrailing then
      r := RectF(r.Left, r.Top, r.Right, r.Bottom - fh)
    else if it.VerticalTextAlign = gtaLeading then
      r := RectF(r.Left, r.Top + fh, r.Right, r.Bottom)
    else
      r := RectF(r.Left, r.Top, r.Right, r.Bottom);

    a := True;
    DoItemBeforeDrawContent(AGraphics, r, it.Index, a);
    if a then
    begin
      DoItemDrawContent(AGraphics, r, it);
      DoItemAfterDrawContent(AGraphics, r, it.Index);
    end;
  end;
end;

procedure TTMSFNCCustomList.DrawItems(AGraphics: TTMSFNCGraphics);
var
  I: Integer;
begin
  for I := 0 to FDisplayList.Count - 1 do
    DrawItem(AGraphics, FDisplayList[I]);
end;

procedure TTMSFNCCustomList.DrawItemText(AGraphics: TTMSFNCGraphics;
  ADisplayItem: TTMSFNCCustomListDisplayItem);
var
  r: TRectF;
  it: TTMSFNCCustomListItem;
  str: String;
  a: Boolean;
begin
  it := ADisplayItem.Item;
  if Assigned(it) and (it.Text <> '') then
  begin
    r := ADisplayItem.Rect;
    str := it.Text;
    a := True;
    InflateRectEx(r, ScalePaintValue(-2), ScalePaintValue(-2));

    DoItemBeforeDrawText(AGraphics, ADisplayItem.Rect, it.Index, str, a);
    if a then
    begin
      AGraphics.DrawText(r, str, False, it.HorizontalTextAlign, it.VerticalTextAlign, gttCharacter);
      DoItemAfterDrawText(AGraphics, ADisplayItem.Rect, it.Index, str);
    end;
  end;
end;

procedure TTMSFNCCustomList.EndUpdate;
begin
  inherited;
  Dec(FUpdateCount);
  if FUpdateCount = 0 then
    CalculateItems;
end;

function TTMSFNCCustomList.GetFirstSelectableItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result := FFocusedItemIndex;
  for I := 0 to FDisplayList.Count - 1 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetHintString: string;
var
  it: TTMSFNCCustomListItem;
begin
  Result := inherited;
  if (FHoveredItemIndex >= 0) and (FHoveredItemIndex <= FItems.Count - 1) then
  begin
    it := FItems[FHoveredItemIndex];
    Result := it.Hint;
  end;
end;

function TTMSFNCCustomList.GetLastSelectableItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result := FFocusedItemIndex;
  for I := FDisplayList.Count - 1 downto 0 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetNextSelectableItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result := FFocusedItemIndex;
  for I := 0 to FDisplayList.Count - 1 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled and (it.Index > FFocusedItemIndex) then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetNextSelectableRowItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
  disp: TTMSFNCCustomListDisplayItem;
begin
  Result := FFocusedItemIndex;
  if Result = -1 then
  begin
    Result := GetNextSelectableItem;
    Exit;
  end;

  disp := GetDisplayItem(FFocusedItemIndex);
  for I := 0 to FDisplayList.Count - 1 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled and (it.Index > FFocusedItemIndex) and (disp.Column >= FDisplayList[I].Column) and
      (disp.Column <= FDisplayList[I].Column + (FDisplayList[I].ColumnSpan - 1))
      and (FDisplayList[I].Row > disp.Row) then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetPreviousSelectableItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result := FFocusedItemIndex;
  for I := FDisplayList.Count - 1 downto 0 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled and (it.Index < FFocusedItemIndex) then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetPreviousSelectableRowItem: Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
  disp: TTMSFNCCustomListDisplayItem;
begin
  Result := FFocusedItemIndex;
  if Result = -1 then
  begin
    Result := GetPreviousSelectableItem;
    Exit;
  end;

  disp := GetDisplayItem(FFocusedItemIndex);
  for I := FDisplayList.Count - 1 downto 0 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and it.Enabled and (it.Index < FFocusedItemIndex) and (disp.Column >= FDisplayList[I].Column) and
      (disp.Column <= FDisplayList[I].Column + (FDisplayList[I].ColumnSpan - 1)) and (FDisplayList[I].Row < disp.Row) then
    begin
      Result := it.Index;
      Break;
    end;
  end;
end;

function TTMSFNCCustomList.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCCustomList.HandleKeyDown(var Key: Word; Shift: TShiftState);
begin
  inherited;
  if Key in [KEY_UP, KEY_DOWN, KEY_LEFT, KEY_RIGHT, KEY_HOME, KEY_END] then
  begin
    case Key of
      KEY_UP: FFocusedItemIndex := GetPreviousSelectableRowItem;
      KEY_LEFT: FFocusedItemIndex := GetPreviousSelectableItem;
      KEY_DOWN: FFocusedItemIndex := GetNextSelectableRowItem;
      KEY_RIGHT: FFocusedItemIndex := GetNextSelectableItem;
      KEY_HOME: FFocusedItemIndex := GetFirstSelectableItem;
      KEY_END: FFocusedItemIndex := GetLastSelectableItem;
    end;
    InvalidateItems;
  end;

  if (Key = KEY_RETURN) then
  begin
    FDownItemIndex := FFocusedItemIndex;
    InvalidateItems;
  end;
end;

procedure TTMSFNCCustomList.HandleKeyUp(var Key: Word; Shift: TShiftState);
begin
  inherited;
  if (Key = KEY_RETURN) then
  begin
    FDownItemIndex := -1;
    ProcessSelection(FFocusedItemIndex);
    InvalidateItems;
  end;
end;

procedure TTMSFNCCustomList.HandleMouseDown(Button: TTMSFNCMouseButton;
  Shift: TShiftState; X, Y: Single);
begin
  inherited;
  CaptureEx;
  FDownItemIndex := XYToItem(X, Y);
  InvalidateItems;
  FDownX := X;
  FDownY := Y;
  FDragItemIndex := -1;
end;

procedure TTMSFNCCustomList.HandleMouseMove(Shift: TShiftState; X, Y: Single);
var
  h: Integer;
begin
  inherited;
  if Animating or IsScrolling then
    Exit;

  if (FDownItemIndex <> -1) and ((Abs(X - FDownX) > 3) or (Abs(Y - FDownY) > 3)) then
  begin
    FDragItemIndex := FDownItemIndex;
    ReleaseCaptureEx;
    FDownItemIndex := -1;
    FHoveredItemIndex := -1;
    Invalidate;
    BeginDrag;
  end;

  if FDownItemIndex > -1 then
    Exit;

  h := XYToItem(X, Y);
  if h <> FHoveredItemIndex then
  begin
    FHoveredItemIndex := h;
    CancelHint;
    InvalidateItems;
  end;
end;

procedure TTMSFNCCustomList.HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState;
  X, Y: Single);
var
  s: Integer;
begin
  inherited;
  if ((Abs(X - FDownX) <= 3) and (Abs(Y - FDownY) <= 3)) and not Animating or IsScrolling then
  begin
    ReleaseCaptureEx;
    s := XYToItem(X, Y);
    if (s = FDownItemIndex) and (FDownItemIndex <> -1) then
    begin
      ProcessSelection(s);
      if s <> -1 then
        DoItemClick(s);
    end;
  end;
  FDownItemIndex := -1;
  FHoveredItemIndex := -1;
  InvalidateItems;
end;

procedure TTMSFNCCustomList.HandleMouseWheel(Shift: TShiftState;
  WheelDelta: Integer; var Handled: Boolean);
var
  vpos, hpos: Double;
  sz: Single;
  dsp: TTMSFNCCustomListDisplayItem;
begin
  inherited;
  vpos := GetVScrollValue;
  hpos := GetHScrollValue;

  sz := 0;
  if Assigned(FDisplayList) and (FDisplayList.Count > 0) then
  begin
    dsp := FDisplayList[FDisplayList.Count - 1];
    sz := dsp.AbsRect.Bottom - dsp.AbsRect.Top + Appearance.VerticalSpacing;
  end;

  if WheelDelta > 0 then
    Scroll(hpos, vpos - sz)
  else
    Scroll(hpos, vpos + sz);

  Handled := True;
end;

function TTMSFNCCustomList.HasHint: Boolean;
var
  it: TTMSFNCCustomListItem;
begin
  Result := False;
  if (FHoveredItemIndex >= 0) and (FHoveredItemIndex <= FItems.Count - 1) then
  begin
    it := FItems[FHoveredItemIndex];
    Result := it.Hint <> '';
  end;
end;

procedure TTMSFNCCustomList.HorizontalScrollPositionChanged;
begin
  inherited;
  CalculateItems;
end;

procedure TTMSFNCCustomList.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  a: Boolean;
begin
  inherited;
  a := True;
  DoBeforeDraw(AGraphics, ARect, a);
  if a then
  begin
    DrawItems(AGraphics);
    DoAfterDraw(AGraphics, ARect);
  end;
end;

procedure TTMSFNCCustomList.ProcessSelection(AItemIndex: Integer);
var
  it: TTMSFNCCustomListItem;
  prev: Integer;
begin
  if FSelectedItemIndex = AItemIndex then
    Exit;

  if (AItemIndex >= 0) and (AItemIndex <= Items.Count - 1) then
  begin
    it := FItems[AItemIndex];
    if it.CanSelect then
    begin
      prev := FSelectedItemIndex;
      if it.CanDeselect and (it.Selected) then
      begin
        FSelectedItemIndex := -1;
        it.Selected := False;
      end
      else
      begin
        FSelectedItemIndex := it.Index;
        it.Selected := True;
      end;

      if FSelectedItemIndex <> -1 then
        FFocusedItemIndex := FSelectedItemIndex;

      if (not AllowMultiSelect) and (prev >= 0) and (prev <= Items.Count - 1) and (prev <> FSelectedItemIndex) then
        FItems[prev].Selected := False;

      if it.CanDeselect and (prev <> -1) then
        DoItemDeSelected(prev);

      if FSelectedItemIndex <> -1 then
        DoItemSelected(FSelectedItemIndex);
    end;
  end;
end;

procedure TTMSFNCCustomList.Rebuild;
begin
end;

procedure TTMSFNCCustomList.InvalidateItems;
begin
  Invalidate;
end;

procedure TTMSFNCCustomList.ResetToDefaultStyle;
begin
  inherited;
  Fill.Kind := gfkSolid;
  Stroke.Kind := gskSolid;
  Fill.Color := gcWhite;
  Stroke.Color := gcSilver;

  Appearance.Fill.Color := Lighter(gcLightgray, 50);
  Appearance.FillHover.Color := Lighter(gcLightslategray, 50);
  Appearance.FillDown.Color := Lighter(gcSlategray, 50);
  Appearance.FillSelected.Color := Lighter(gcSlategray, 50);
  Appearance.FillDisabled.Color := Lighter(gcGray, 50);

  Appearance.Stroke.Color := gcDarkgray;
  Appearance.StrokeHover.Color := gcLightslategray;
  Appearance.StrokeDown.Color := gcSlategray;
  Appearance.StrokeSelected.Color := gcDarkslategray;
  Appearance.StrokeDisabled.Color := gcDarkgray;

  Appearance.Font.Color := gcBlack;

  Appearance.Fill.Kind := gfkSolid;
  Appearance.FillHover.Kind := gfkSolid;
  Appearance.FillDown.Kind := gfkSolid;
  Appearance.FillSelected.Kind := gfkSolid;
  Appearance.FillDisabled.Kind := gfkSolid;

  Appearance.Stroke.Kind := gskSolid;
  Appearance.StrokeHover.Kind := gskSolid;
  Appearance.StrokeDown.Kind := gskSolid;
  Appearance.StrokeSelected.Kind := gskSolid;
  Appearance.StrokeDisabled.Kind := gskSolid;
end;

procedure TTMSFNCCustomList.UpdateControlAfterResize;
begin
  inherited;
  CalculateItems;
end;

procedure TTMSFNCCustomList.UpdateControlScroll(AHorizontalPos,
  AVerticalPos, ANewHorizontalPos, ANewVerticalPos: Double);
begin
  inherited;
  CalculateItems;
end;

procedure TTMSFNCCustomList.VerticalScrollPositionChanged;
begin
  inherited;
  CalculateItems;
end;

function TTMSFNCCustomList.GetDisplayItem(AItemIndex: Integer): TTMSFNCCustomListDisplayItem;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result.Rect := RectF(0, 0, 0, 0);
  Result.Item := nil;
  Result.PageIndex := -1;
  Result.Row := -1;
  Result.Column := -1;
  Result.ColumnSpan := -1;
  Result.RowSpan := -1;
  for I := 0 to FDisplayList.Count - 1 do
  begin
    it := FDisplayList[I].Item;
    if Assigned(it) and (it.Index = AItemIndex) then
    begin
      Result := FDisplayList[I];
      Break;
    end;
  end;
end;

procedure TTMSFNCCustomList.SetAllowMultiSelect(const Value: Boolean);
begin
  FAllowMultiSelect := Value;
end;

procedure TTMSFNCCustomList.SetAppearance(
  const Value: TTMSFNCCustomListAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCCustomList.SetColumns(const Value: Integer);
begin
  if FColumns <> Value then
  begin
    FColumns := Value;
    CalculateItems;
  end;
end;

procedure TTMSFNCCustomList.SetItems(const Value: TTMSFNCCustomListItems);
begin
  FItems.Assign(Value);
end;

procedure TTMSFNCCustomList.SetOrientation(
  const Value: TTMSFNCCustomListOrientation);
begin
  if FOrientation <> Value then
  begin
    FOrientation := Value;

    if FOrientation = toVertical then
    begin
      Appearance.ItemWidth := -1;
      Columns := 1;
    end
    else
    begin
      Appearance.ItemHeight := -1;
      Rows := 1;
    end;

    if ComponentState * [csLoading, csUpdating] = [] then
    begin
      {$IFDEF FMXLIB}
      SetBounds(Position.x, Position.Y, Height, Width);
      {$ENDIF}
      {$IFNDEF FMXLIB}
      SetBounds(Left, Top, Height, Width);
      {$ENDIF}
    end;
  end;
end;

procedure TTMSFNCCustomList.SetRows(const Value: Integer);
begin
  if FRows <> Value then
  begin
    FRows := Value;
    CalculateItems;
  end;
end;

procedure TTMSFNCCustomList.SetSelectedItemIndex(const Value: Integer);
begin
  if FSelectedItemIndex <> Value then
  begin
    FSelectedItemIndex := Value;
    FFocusedItemIndex := Value;
    InvalidateItems;
  end;
end;

function TTMSFNCCustomList.XYToItem(X, Y: Single): Integer;
var
  I: Integer;
  it: TTMSFNCCustomListItem;
begin
  Result := -1;
  for I := 0 to FDisplayList.Count - 1 do
  begin
    if PtInRectEx(FDisplayList[I].Rect, PointF(X, Y)) then
    begin
      it := FDisplayList[I].Item;
      if Assigned(it) and it.Enabled and not it.Empty then
      begin
        Result := it.Index;
        Break;
      end;
    end;
  end;
end;

{ TTMSFNCCustomListItem }

procedure TTMSFNCCustomListItem.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCCustomListItem then
  begin
    FRowSpan := (Source as TTMSFNCCustomListItem).RowSpan;
    FColumnSpan := (Source as TTMSFNCCustomListItem).ColumnSpan;
    FVisible := (Source as TTMSFNCCustomListItem).Visible;
    FEmpty := (Source as TTMSFNCCustomListItem).Empty;
    FText := (Source as TTMSFNCCustomListItem).Text;
    FEnabled := (Source as TTMSFNCCustomListItem).Enabled;
    FMargins.Assign((Source as TTMSFNCCustomListItem).Margins);
    FCanDeselect := (Source as TTMSFNCCustomListItem).CanDeselect;
    FCanSelect := (Source as TTMSFNCCustomListItem).CanSelect;
    FHint := (Source as TTMSFNCCustomListItem).Hint;
    FVerticalTextAlign := (Source as TTMSFNCCustomListItem).VerticalTextAlign;
    FHorizontalTextAlign := (Source as TTMSFNCCustomListItem).HorizontalTextAlign;
    FSelected := (Source as TTMSFNCCustomListItem).Selected;
    FText := (Source as TTMSFNCCustomListItem).Text;
  end;
end;

constructor TTMSFNCCustomListItem.Create(ACollection: TCollection);
begin
  inherited;
  FSelected := False;
  FHorizontalTextAlign := gtaCenter;
  FVerticalTextAlign := gtaCenter;
  if Assigned(ACollection) then
    FOwner := (Collection as TTMSFNCCustomListItems).FOwner;
  FColumnSpan := 1;
  FCanDeselect := True;
  FCanSelect := True;
  FRowSpan := 1;
  FMargins := TTMSFNCMargins.Create;
  FMargins.OnChange := @MarginsChanged;
  FEnabled := True;
  FVisible := True;
  FEmpty := False;
  if Assigned(FOwner) then
    FOwner.CalculateItems;
end;

destructor TTMSFNCCustomListItem.Destroy;
begin
  FMargins.Free;
  inherited;
  if Assigned(FOwner) then
    FOwner.CalculateItems;
end;

procedure TTMSFNCCustomListItem.MarginsChanged(Sender: TObject);
begin
  FOwner.CalculateItems;
end;

procedure TTMSFNCCustomListItem.InvalidateItems;
begin
  FOwner.InvalidateItems;
end;

procedure TTMSFNCCustomListItem.SetCanDeselect(const Value: Boolean);
begin
  FCanDeselect := Value;
end;

procedure TTMSFNCCustomListItem.SetCanSelect(const Value: Boolean);
begin
  FCanSelect := Value;
end;

procedure TTMSFNCCustomListItem.SetColumnSpan(const Value: Integer);
begin
  if FColumnSpan <> Value then
  begin
    FColumnSpan := Value;
    FOwner.CalculateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetEmpty(const Value: Boolean);
begin
  if FEmpty <> Value then
  begin
    FEmpty := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetEnabled(const Value: Boolean);
begin
  if FEnabled <> Value then
  begin
    FEnabled := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetHorizontalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FHorizontalTextAlign <> Value then
  begin
    FHorizontalTextAlign := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetMargins(const Value: TTMSFNCMargins);
begin
  FMargins.Assign(Value);
end;

procedure TTMSFNCCustomListItem.SetRowSpan(const Value: Integer);
begin
  if FRowSpan <> Value then
  begin
    FRowSpan := Value;
    FOwner.CalculateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetSelected(const Value: Boolean);
begin
  if FSelected <> Value then
  begin
    FSelected := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetText(const Value: String);
begin
  if FText <> Value then
  begin
    FText := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetVerticalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FVerticalTextAlign <> Value then
  begin
    FVerticalTextAlign := Value;
    FOwner.InvalidateItems;
  end;
end;

procedure TTMSFNCCustomListItem.SetVisible(const Value: Boolean);
begin
  if FVisible <> Value then
  begin
    FVisible := Value;
    FOwner.CalculateItems;
  end;
end;

function TTMSFNCCustomListItem.State: TTMSFNCCustomListItemState;
begin
  Result := isNormal;
  if Enabled then
  begin
    if Index = FOwner.FDownItemIndex then
      Result := isDown
    else if Index = FOwner.FHoveredItemIndex then
      Result := isHover
    else if FSelected then
      Result := isSelected
  end
  else
    Result := isDisabled;
end;

{ TTMSFNCCustomListItems }

function TTMSFNCCustomListItems.Add: TTMSFNCCustomListItem;
begin
  Result := TTMSFNCCustomListItem(inherited Add);
end;

constructor TTMSFNCCustomListItems.Create(AOwner: TTMSFNCCustomList);
begin
  inherited Create(AOwner, CreateItemClass);
  FOwner := AOwner;
end;

function TTMSFNCCustomListItems.CreateItemClass: TCollectionItemClass;
begin
  Result := TTMSFNCCustomListItem;
end;

function TTMSFNCCustomListItems.GetItem(
  Index: Integer): TTMSFNCCustomListItem;
begin
  Result := TTMSFNCCustomListItem(inherited Items[Index]);
end;

function TTMSFNCCustomListItems.GetOwner: TPersistent;
begin
  Result := FOwner;
end;

function TTMSFNCCustomListItems.Insert(
  Index: Integer): TTMSFNCCustomListItem;
begin
  Result := TTMSFNCCustomListItem(inherited Insert(Index));
end;

procedure TTMSFNCCustomListItems.SetItem(Index: Integer;
  const Value: TTMSFNCCustomListItem);
begin
  inherited Items[Index] := Value;
end;

{ TTMSFNCCustomListAppearance }

procedure TTMSFNCCustomListAppearance.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCCustomListAppearance then
  begin
    FFill.Assign((Source as TTMSFNCCustomListAppearance).Fill);
    FFillHover.Assign((Source as TTMSFNCCustomListAppearance).FillHover);
    FFillSelected.Assign((Source as TTMSFNCCustomListAppearance).FillSelected);
    FFillDisabled.Assign((Source as TTMSFNCCustomListAppearance).FillDisabled);
    FFillDown.Assign((Source as TTMSFNCCustomListAppearance).FillDown);
    FStroke.Assign((Source as TTMSFNCCustomListAppearance).Stroke);
    FStrokeHover.Assign((Source as TTMSFNCCustomListAppearance).StrokeHover);
    FStrokeSelected.Assign((Source as TTMSFNCCustomListAppearance).StrokeSelected);
    FStrokeDown.Assign((Source as TTMSFNCCustomListAppearance).StrokeDown);
    FStrokeDisabled.Assign((Source as TTMSFNCCustomListAppearance).StrokeDisabled);
    FVerticalSpacing := (Source as TTMSFNCCustomListAppearance).VerticalSpacing;
    FHorizontalSpacing := (Source as TTMSFNCCustomListAppearance).HorizontalSpacing;
    FFont.Assign((Source as TTMSFNCCustomListAppearance).Font);
    FTextFormat := (Source as TTMSFNCCustomListAppearance).TextFormat;
  end;
end;

procedure TTMSFNCCustomListAppearance.Changed;
begin
  FOwner.CalculateItems;
end;

constructor TTMSFNCCustomListAppearance.Create(AOwner: TTMSFNCCustomList);
begin
  FOwner := AOwner;

  FItemHeight := -1;
  FItemWidth := -1;

  FTextFormat := '%s';

  FFill := TTMSFNCGraphicsFill.Create;
  FFillHover := TTMSFNCGraphicsFill.Create;
  FFillHover.Color := Lighter(gcLightslategray, 50);
  FFillDown := TTMSFNCGraphicsFill.Create;
  FFillDown.Color := Lighter(gcSlategray, 50);
  FFillSelected := TTMSFNCGraphicsFill.Create;
  FFillSelected.Color := Lighter(gcSlategray, 50);
  FFillDisabled := TTMSFNCGraphicsFill.Create;
  FFillDisabled.Color := Lighter(gcGray, 50);

  FStroke := TTMSFNCGraphicsStroke.Create;
  FStroke.Color := gcDarkgray;
  FStrokeHover := TTMSFNCGraphicsStroke.Create;
  FStrokeHover.Color := gcLightslategray;
  FStrokeDown := TTMSFNCGraphicsStroke.Create;
  FStrokeDown.Color := gcSlategray;
  FStrokeSelected := TTMSFNCGraphicsStroke.Create;
  FStrokeSelected.Color := gcDarkslategray;
  FStrokeDisabled := TTMSFNCGraphicsStroke.Create;
  FStrokeDisabled.Color := gcDarkgray;

  FFont := TTMSFNCGraphicsFont.Create;
  FFont.OnChanged := @FontChanged;

  FFill.OnChanged := @FillChanged;
  FFillDown.OnChanged := @FillChanged;
  FFillHover.OnChanged := @FillChanged;
  FFillSelected.OnChanged := @FillChanged;
  FFillDisabled.OnChanged := @FillChanged;

  FStroke.OnChanged := @StrokeChanged;
  FStrokeHover.OnChanged := @StrokeChanged;
  FStrokeDown.OnChanged := @StrokeChanged;
  FStrokeDisabled.OnChanged := @StrokeChanged;
  FStrokeSelected.OnChanged := @StrokeChanged;

  FHorizontalSpacing := 4;
  FVerticalSpacing := 4;
end;

destructor TTMSFNCCustomListAppearance.Destroy;
begin
  FFont.Free;
  FFill.Free;
  FFillDown.Free;
  FFillSelected.Free;
  FFillHover.Free;
  FFillDisabled.Free;
  FStroke.Free;
  FStrokeDown.Free;
  FStrokeSelected.Free;
  FStrokeHover.Free;
  FStrokeDisabled.Free;
  inherited;
end;

procedure TTMSFNCCustomListAppearance.FillChanged(Sender: TObject);
begin
  FOwner.InvalidateItems;
end;

procedure TTMSFNCCustomListAppearance.FontChanged(Sender: TObject);
begin
  FOwner.InvalidateItems;
end;

function TTMSFNCCustomListAppearance.IsHorizontalSpacingStored: Boolean;
begin
  Result := HorizontalSpacing <> 4;
end;

function TTMSFNCCustomListAppearance.IsItemHeightStored: Boolean;
begin
  Result := ItemHeight <> -1;
end;

function TTMSFNCCustomListAppearance.IsItemWidthStored: Boolean;
begin
  Result := ItemWidth <> -1;
end;

function TTMSFNCCustomListAppearance.IsTextFormatStored: Boolean;
begin
  Result := FTextFormat <> '%s';
end;

function TTMSFNCCustomListAppearance.IsVerticalSpacingStored: Boolean;
begin
  Result := VerticalSpacing <> 4;
end;

procedure TTMSFNCCustomListAppearance.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  FFill.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetFillDisabled(const Value: TTMSFNCGraphicsFill);
begin
  FFillDisabled.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetFillDown(const Value: TTMSFNCGraphicsFill);
begin
  FFillDown.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetFillHover(const Value: TTMSFNCGraphicsFill);
begin
  FFillHover.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetFillSelected(const Value: TTMSFNCGraphicsFill);
begin
  FFillSelected.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetFont(const Value: TTMSFNCGraphicsFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetHorizontalSpacing(
  const Value: Single);
begin
  if FHorizontalSpacing <> Value then
  begin
    FHorizontalSpacing := Value;
    Changed;
  end;
end;

procedure TTMSFNCCustomListAppearance.SetItemHeight(const Value: Single);
begin
  if FItemHeight <> Value then
  begin
    FItemHeight := Value;
    Changed;
  end;
end;

procedure TTMSFNCCustomListAppearance.SetItemWidth(const Value: Single);
begin
  if FItemWidth <> Value then
  begin
    FItemWidth := Value;
    Changed;
  end;
end;

procedure TTMSFNCCustomListAppearance.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetStrokeDisabled(
  const Value: TTMSFNCGraphicsStroke);
begin
  FStrokeDisabled.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetStrokeDown(
  const Value: TTMSFNCGraphicsStroke);
begin
  FStrokeDown.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetStrokeHover(
  const Value: TTMSFNCGraphicsStroke);
begin
  FStrokeHover.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetStrokeSelected(
  const Value: TTMSFNCGraphicsStroke);
begin
  FStrokeSelected.Assign(Value);
end;

procedure TTMSFNCCustomListAppearance.SetTextFormat(
  const Value: string);
begin
  if FTextFormat <> Value then
  begin
    FTextFormat := Value;
    Changed;
  end;
end;

procedure TTMSFNCCustomListAppearance.SetVerticalSpacing(const Value: Single);
begin
  if FVerticalSpacing <> Value then
  begin
    FVerticalSpacing := Value;
    Changed;
  end;
end;

procedure TTMSFNCCustomListAppearance.StrokeChanged(Sender: TObject);
begin
  FOwner.InvalidateItems;
end;

{$IFDEF LCLLIB}
class operator TTMSFNCCustomListDisplayItem.=(z1, z2: TTMSFNCCustomListDisplayItem)b: boolean;
begin
  Result := z1 = z2;
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCCustomListDisplayList }

function TTMSFNCCustomListDisplayList.GetItem(Index: Integer): TTMSFNCCustomListDisplayItem;
begin
  Result := TTMSFNCCustomListDisplayItem(inherited Items[Index]);
end;

procedure TTMSFNCCustomListDisplayList.SetItem(Index: Integer; const Value: TTMSFNCCustomListDisplayItem);
var
  v: TTMSFNCCustomListDisplayItem;
begin
  v := Value;
  inherited Items[Index] := v;
end;
{$ENDIF}

{ TTMSFNCCustomList }

//procedure TTMSFNCCustomList.RegisterRuntimeClasses;
//begin
//  inherited;
//  RegisterClass(TTMSFNCCustomList);
//end;

initialization
  RegisterClass(TTMSFNCCustomList);

end.
